import { Component, Input, Output, OnInit, OnDestroy, ViewChild, EventEmitter } from '@angular/core';
import { ApiMessage } from '@bhtp-client-api/base';
import { ModalService } from '@bhtp-client-web/component';
import { Observable, Subject, Subscription } from 'rxjs';
import { NavigationStepComponent } from './navigation-step.component';
import { PurchaseNavigationService } from './purchase-navigation.service';
import { WriteValueOverride } from './models';
import { PurchaseData, PaymentFormData, PaymentIFrameComponent, Agent, CreditAgentFormData, AmbassadorInformationSessionStorage } from '../shared';

@Component({
    selector: 'purchase-step',
    template: require('./purchase-step.component.html')
})
export class PurchaseStepComponent extends NavigationStepComponent {
    @Input() agent: Agent;
    @Input() handlePurchaseError: Subject<ApiMessage[]> = new Subject();
    @Output() onPaymentSuccess: EventEmitter<PaymentFormData> = new EventEmitter<PaymentFormData>();

    @ViewChild('paymentFormComponent')
    public paymentFormComponent: PaymentIFrameComponent;
    public paymentFormData: PaymentFormData;
    public creditAgentFormData: CreditAgentFormData;

    private handlePurchaseErrorSubscription: Subscription;

    constructor(navigationService: PurchaseNavigationService, private modalService: ModalService) {
        super(navigationService);
    }

    public ngOnInit(): void {
        this.handlePurchaseErrorSubscription = this.handlePurchaseError.subscribe((error: ApiMessage[]) => {
            this.paymentFormComponent.reloadIFrame();
        });
    }

    public ngOnDestroy(): void {
        this.handlePurchaseErrorSubscription.unsubscribe();
    }

    public canContinue(): Observable<boolean> {
        return Observable.of(true);
    }

    public writeValues(purchaseData: PurchaseData, override: WriteValueOverride = WriteValueOverride.Default): void {
        purchaseData.billing = this.paymentFormData.billing;

        if (this.agent.isAmbassador) {
            purchaseData.agentCode = this.creditAgentFormData.agentCode;
            purchaseData.agencyCode = this.creditAgentFormData.agencyCode;
        }
    }

    public buildForm(): void {
        // create purchase data to be passed to payment form
        let data: PaymentFormData = new PaymentFormData();

        if (this.currentPurchaseData.purchaseForOther) {
            // need to get agent
            data.agent = this.agent;
            data.address = this.currentPurchaseData.policyBuyer.address;
            data.emailAddress = this.currentPurchaseData.policyBuyer.emailGroup.email;
            data.firstName = this.currentPurchaseData.policyBuyer.firstName;
            data.lastName = this.currentPurchaseData.policyBuyer.lastName;
            data.primaryTravelerName = data.firstName + ' ' + data.lastName;
            data.billing = this.currentPurchaseData.billing;
        }
        else {
            // need to get agent
            data.agent = this.agent;
            data.address = this.currentPurchaseData.primaryTraveler.address;
            data.emailAddress = this.currentPurchaseData.primaryTraveler.emailGroup.email;
            data.firstName = this.currentPurchaseData.primaryTraveler.firstName;
            data.lastName = this.currentPurchaseData.primaryTraveler.lastName;
            data.primaryTravelerName = data.firstName + ' ' + data.lastName;
            data.billing = this.currentPurchaseData.billing;
        }

        this.paymentFormData = data;

        // create credit agent data to be passed to the credit agent form
        let credit: CreditAgentFormData = new CreditAgentFormData();
        credit.agentCode = this.currentPurchaseData.agentCode;
        credit.agencyCode = this.currentPurchaseData.agencyCode;
        this.creditAgentFormData = credit;
    }

    public onPaymentRespond(paymentFormData: PaymentFormData): void {
        if (this.onPaymentSuccess) {
            this.onPaymentSuccess.emit(paymentFormData);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/purchase-step.component.ts